module.exports = __webpack_public_path__ + "static/media/company-logo-large.dcf15f32.png";